/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assetsInfoE.vue?vue&type=template&id=94e8e946"
import script from "./assetsInfoE.vue?vue&type=script&lang=js"
export * from "./assetsInfoE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports